import { GLTFExporter } from "three/examples/jsm/exporters/GLTFExporter.js"

export const exportGlb = (root) =>
  new Promise((resolve, reject) => {
    const exporter = new GLTFExporter()
    exporter.parse(
      root,
      (result) => {
        if (result instanceof ArrayBuffer) {
          resolve(result)
          return
        }

        reject(new Error("GLB export did not return binary data"))
      },
      (error) => reject(error),
      { binary: true, onlyVisible: false }
    )
  })

const MODEL_CACHE_NAME = "digital-twin-plan-models-v1"

export const fetchCachedArrayBuffer = async (url, options = {}) => {
  const { onCacheHit, onCacheMiss } = options
  const request = new Request(url, {
    method: "GET",
    credentials: "same-origin"
  })

  if (!("caches" in window)) {
    onCacheMiss?.()
    const response = await fetch(request)
    if (!response.ok) throw new Error(`Request failed with status ${response.status}`)
    return { arrayBuffer: await response.arrayBuffer(), cacheHit: false }
  }

  const cache = await window.caches.open(MODEL_CACHE_NAME)
  const cachedResponse = await cache.match(request)
  if (cachedResponse?.ok) {
    onCacheHit?.()
    return { arrayBuffer: await cachedResponse.arrayBuffer(), cacheHit: true }
  }

  onCacheMiss?.()
  const response = await fetch(request)
  if (!response.ok) throw new Error(`Request failed with status ${response.status}`)

  try {
    await cache.put(request, response.clone())
  } catch (_error) {
    // Ignore cache write failures and continue with the fetched model.
  }

  return { arrayBuffer: await response.arrayBuffer(), cacheHit: false }
}

export const parseGltfFromArrayBuffer = (loader, arrayBuffer, url) =>
  new Promise((resolve, reject) => {
    loader.parse(
      arrayBuffer,
      url,
      (gltf) => resolve(gltf),
      (error) => reject(error instanceof Error ? error : new Error("Could not parse the model file."))
    )
  })
